export * from './LoadingIndicator';

import LoadingIndicator from './LoadingIndicator';
export default LoadingIndicator;
